import { useShallow } from "zustand/shallow";

import { VoteType } from "api/vote";
import Participants from "containers/Participants";
import useBoundStore from "store";

interface EventParticipantsVotesProps {
  onBack?: () => void;
}

export default function EventParticipantsVotes(props: EventParticipantsVotesProps): JSX.Element {
  const { onBack } = props;
  const selected = useBoundStore((state) => state.selected);
  const { groups, groupsUsers, votes } = useBoundStore(
    useShallow((state) => ({
      groups: state.appData.groups,
      groupsUsers: state.appData.groupsUsers,
      votes: state.appData.votes,
    }))
  );
  const group = groups.find((g) => g.id === selected.groupId);
  const users = groupsUsers.filter((user) => group?.users.includes(user.uid));
  let participantsVotes = votes.filter((vote) => vote.event_id === selected.eventId);
  participantsVotes = participantsVotes.filter((vote) => vote.type === VoteType.PARTICIPATING);

  return <Participants users={users} votes={participantsVotes} onBack={onBack} />;
}
